var _rect, _text, _path, _circle, _path2, _text2, _text3, _text4, _circle2, _circle3, _circle4, _path3, _text5, _text6, _text7, _circle5, _rect2, _path4, _text8, _text9, _text0, _circle6, _path5, _path6, _text1, _text10, _text11, _circle7, _path7, _text12, _text13, _text14, _path8, _rect3, _circle8, _path9, _path0, _text15, _text16, _text17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkPassportConnectedComplianceLoopFiveStageProcessDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1400,
    height: 480,
    viewBox: "0 0 1400 480",
    role: "img",
    "aria-label": "Connected compliance loop desktop diagram",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1400,
    height: 480,
    rx: 38,
    fill: "#FFFFFF",
    stroke: "#D5E3F2"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 62,
    fill: "#087CFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 13,
    fontWeight: 850,
    letterSpacing: 1.6
  }, "FROM FORECAST RISK TO CURRENT EVIDENCE")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134 218H1118",
    stroke: "#BBD9F5",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 134,
    cy: 218,
    r: 47,
    fill: "#087CFF",
    fillOpacity: 0.11,
    stroke: "#087CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122 229l8-8 6 5 12-14",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 118,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "01")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 304,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 23,
    fontWeight: 850
  }, "Detect")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 134,
    y: 335,
    textAnchor: "middle",
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Upcoming risk")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 372,
    cy: 218,
    r: 47,
    fill: "#F54291",
    fillOpacity: 0.11,
    stroke: "#F54291"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 365,
    cy: 211,
    r: 5,
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 380,
    cy: 212,
    r: 4,
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M356 231c0-8 18-8 18 0M375 230c0-6 14-6 14 0",
    fill: "none",
    stroke: "#F54291",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 372,
    y: 118,
    textAnchor: "middle",
    fill: "#F54291",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "02")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 372,
    y: 304,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 23,
    fontWeight: 850
  }, "Group")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 372,
    y: 335,
    textAnchor: "middle",
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Efficient cohort")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 610,
    cy: 218,
    r: 47,
    fill: "#F5AE35",
    fillOpacity: 0.11,
    stroke: "#F5AE35"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 206,
    width: 28,
    height: 25,
    rx: 3,
    fill: "none",
    stroke: "#F5AE35",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M596 214h28M603 202v7M617 202v7",
    fill: "none",
    stroke: "#F5AE35",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 118,
    textAnchor: "middle",
    fill: "#F5AE35",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "03")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 304,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 23,
    fontWeight: 850
  }, "Schedule")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 335,
    textAnchor: "middle",
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Options issued")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 848,
    cy: 218,
    r: 47,
    fill: "#4BB5FF",
    fillOpacity: 0.11,
    stroke: "#4BB5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M835 230v-24h26v24M841 213h14M841 220h10",
    fill: "none",
    stroke: "#4BB5FF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M842 226l4 4 8-9",
    fill: "none",
    stroke: "#4BB5FF",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 848,
    y: 118,
    textAnchor: "middle",
    fill: "#4BB5FF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "04")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 848,
    y: 304,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 23,
    fontWeight: 850
  }, "Train")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 848,
    y: 335,
    textAnchor: "middle",
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Accredited delivery")), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1086,
    cy: 218,
    r: 47,
    fill: "#30D6A1",
    fillOpacity: 0.11,
    stroke: "#30D6A1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1098 212a14 14 0 1 0 1 15M1098 212v-8m0 8h-8",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 1086,
    y: 118,
    textAnchor: "middle",
    fill: "#30D6A1",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 12,
    fontWeight: 850,
    letterSpacing: 1
  }, "05")), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 1086,
    y: 304,
    textAnchor: "middle",
    fill: "#07152A",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 23,
    fontWeight: 850
  }, "Update")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 1086,
    y: 335,
    textAnchor: "middle",
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 650
  }, "Evidence refreshed")), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1167 218h52m-10-10 10 10-10 10",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1240,
    y: 136,
    width: 112,
    height: 164,
    rx: 25,
    fill: "#07152A"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1296,
    cy: 196,
    r: 27,
    fill: "#30D6A1",
    fillOpacity: 0.14
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1296 184.48l10.08 3.5999999999999996v7.199999999999999c0 6.4799999999999995-4.32 10.799999999999999-10.08 13.68-10.08-2.88-10.08-7.199999999999999-10.08-13.68v-7.199999999999999z",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 1.728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M1290.96 196l3.5999999999999996 3.5999999999999996 7.199999999999999-7.92",
    fill: "none",
    stroke: "#30D6A1",
    strokeWidth: 1.728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 1296,
    y: 250,
    textAnchor: "middle",
    fill: "#4BB5FF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 10,
    fontWeight: 850
  }, "RESULT")), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 1296,
    y: 275,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 13,
    fontWeight: 850
  }, "SITE READY")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 431,
    fill: "#536985",
    fontFamily: "Inter,Arial,sans-serif",
    fontSize: 14,
    fontWeight: 680
  }, "Management governs rules and exceptions. Work Passport coordinates the recurring action.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkPassportConnectedComplianceLoopFiveStageProcessDesktop);
export default __webpack_public_path__ + "static/media/work-passport-connected-compliance-loop-five-stage-process-desktop.26b2e641d66e235c86ed15593c65b63e.svg";
export { ForwardRef as ReactComponent };